import { render, staticRenderFns } from "./UpdateAnnouncement.vue?vue&type=template&id=12d87f68&scoped=true&"
import script from "./UpdateAnnouncement.vue?vue&type=script&lang=js&"
export * from "./UpdateAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAnnouncement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UpdateAnnouncement.vue?vue&type=style&index=1&id=12d87f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d87f68",
  null
  
)

export default component.exports